const cache = new Map<string, URLSearchParams>();
/**
 * 获取url的searchParams
 * @param key 获取的参数名
 * @param url 获取的url
 * @returns 返回获取的参数值
 * @example
 * getSearchParams() // 不传key, 返回所有参数
 * getSearchParams('projectId') // 传key, 返回参数值
 * getSearchParams('projectId', 'https://example.com?projectId=1&b=2') // 传url, 返回指定url上的参数值
 */
export function getSearchParams(): Record<string, string>;
export function getSearchParams(key: string, url?: string): string;
export function getSearchParams(key?: string, url: string = window.location.href) {
  let searchParams = cache.get(url);
  if (!searchParams) {
    searchParams = new URL(url).searchParams;
    cache.set(url, searchParams);
  }

  return key ? searchParams.get(key) : Object.fromEntries(searchParams.entries());
}

/**
 * 将参数追加到url上
 * @param params 追加的参数
 * @param url 追加的url
 * @returns 返回追加后的url
 * @example
 * appendSearchParamsToUrl({ projectId: '1' }, 'https://example.com?a=1&b=2') // 返回 https://example.com?a=1&b=2&projectId=1
 */
export function appendSearchParamsToUrl(params: Record<string, string> = {}, url = window.location.href) {
  const urlInstance = new URL(url);
  const searchParams = urlInstance.searchParams;
  Object.keys(params).forEach((key) => {
    if (searchParams.has(key)) {
      searchParams.delete(key);
    }
    searchParams.append(key, params[key]);
  });
  return urlInstance.href;
}
